// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_hi-3";
export var flatBottomCorners = "_hi-5";
export var productImage = "_hi-0";
export var quantityContainer = "_hi-2";
export var quantityHeader = "_hi-6";
export var tooltip = "_hi-1";
export var wrapAndEllipsesOverflow = "_hi-4";